<template>
  <div class="card">
    <!-- <div class="card-header">
      <h4 class="title">Driver terminals</h4>
    </div> -->
    <div class="card-body">
      <v-server-table :name="tableName" :url="`/v1/terminals?currentAllocation[submerchantId]=${submerchantId}`"
        :columns="columns" :options="options" :ref="tableName">
        <template slot="serialNumber" slot-scope="props">
          <terminal-fragment :terminalId="props.row.id" :terminalSerialNumber="props.row.serialNumber"
            link-classes="btn btn-link btn-sm" :key="props.row.id"></terminal-fragment>
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { requestAdapter } from "../../../../helpers/tableHelpers";
import TerminalFragment from "src/components/Dashboard/Views/Pages/Terminals/TerminalFragment.vue";

const columns = ["serialNumber"];

export default {
  name: "SubmerchantSalesList",
  components: {
    TerminalFragment
  },
  props: ["submerchantId"],
  methods: {

  },
  data() {
    return {
      columns,
      tableName: `submerchantTerminalsList_${this.submerchantId}`,
      options: {
        table: this.tableName,
        pagination: { chunk: 3 },
        requestAdapter,
        columnsDropdown: false,
        headings: {
          serialNumber: "Terminal"
        }
      }
    };
  }
};
</script>
